document.addEventListener('DOMContentLoaded', () => {
  const popup = document.querySelector('[data-email-popup]');
  if (popup) {
    const key = 'scf-email-popup-dismissed';
    const dismissed = Number(localStorage.getItem(key) || 0);
    const fourteenDays = 14 * 24 * 60 * 60 * 1000;
    if (!dismissed || Date.now() - dismissed > fourteenDays) {
      window.setTimeout(() => {
        popup.hidden = false;
        popup.querySelector('input[type="email"]')?.focus();
      }, 7000);
    }
    const close = () => {
      popup.hidden = true;
      localStorage.setItem(key, String(Date.now()));
    };
    popup.querySelectorAll('[data-email-popup-close]').forEach((button) => button.addEventListener('click', close));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !popup.hidden) close();
    });
  }

  document.querySelectorAll('[data-mobile-nav] a').forEach((link) => link.addEventListener('click', () => {
    const menu = document.querySelector('[data-mobile-nav]');
    const toggle = document.querySelector('[data-menu-toggle]');
    menu?.classList.remove('is-open');
    toggle?.setAttribute('aria-expanded', 'false');
  }));

  const filterDrawer = document.querySelector('[data-filter-drawer]');
  const filterToggle = document.querySelector('[data-filter-open]');
  const closeFilters = () => {
    filterDrawer?.classList.remove('is-open');
    filterToggle?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('filters-open');
    filterToggle?.focus();
  };
  filterToggle?.addEventListener('click', () => {
    filterDrawer?.classList.add('is-open');
    filterToggle.setAttribute('aria-expanded', 'true');
    document.body.classList.add('filters-open');
    window.setTimeout(() => filterDrawer?.querySelector('[data-filter-close]')?.focus(), 30);
  });
  document.querySelectorAll('[data-filter-close]').forEach((button) => button.addEventListener('click', closeFilters));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeFilters(); });

  const sortSelect = document.querySelector('[data-sort-select]');
  sortSelect?.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sortSelect.value);
    window.location.href = url.toString();
  });

});
